import {SearchModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class SellableSearchModel extends SearchModel<any> {
    constructor(injector: Injector) {
        super(injector);
    }

    override getIdentifierField(): string {
        return "sellableId";
    }

    findBySellableId(sellableId: number): Promise<any> {
        return this.searchRecords({sellableId: sellableId}, undefined, undefined, undefined).toPromise()
            .then(searchData => Promise.resolve(searchData.totalCount === 1 ? searchData.data[0] : undefined));
    }
}
